/**
 * StepChip — one item in the PassStudio 2-step stepper header. Purely a
 * back/forward affordance: it reflects the wizard's `step`/`designSaved` state
 * but is NEVER the primary advance control (that is the "Tovább a generáláshoz"
 * button in Step 1, §3.2). Chip 2 is `disabled` until the first save flips
 * `designSaved`, after which it lets the operator hop between steps.
 */

export interface StepChipProps {
  n: 1 | 2;
  active: boolean;
  /** Step 1 has persisted a non-seed design (drives the ✓ marker). */
  done?: boolean;
  /** Chip 2 is not clickable until the first save. */
  disabled?: boolean;
  label: string;
  onClick: () => void;
}

export function StepChip({
  n,
  active,
  done = false,
  disabled = false,
  label,
  onClick,
}: StepChipProps): JSX.Element {
  return (
    <li>
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        aria-current={active ? 'step' : undefined}
        className={`flex items-center gap-2 rounded-full px-3 py-1.5 text-sm font-medium transition ${
          active
            ? 'bg-brand-700 text-white'
            : disabled
              ? 'bg-slate-100 text-slate-400 cursor-not-allowed'
              : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
        }`}
      >
        <span
          className={`grid h-5 w-5 place-items-center rounded-full text-xs ${
            active ? 'bg-white/25' : done ? 'bg-emerald-500 text-white' : 'bg-slate-300 text-white'
          }`}
        >
          {done && !active ? '✓' : n}
        </span>
        {label}
      </button>
    </li>
  );
}
